"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAudioVisualizerContext = void 0;

var react_1 = require("react");

var AudioVisualizerProvider_1 = require("./AudioVisualizerProvider");

var useAudioVisualizerContext = function useAudioVisualizerContext() {
  var _a = (0, react_1.useContext)(AudioVisualizerProvider_1.AudioVisualizerContextProvider),
      audioContext = _a.audioContext,
      analyser = _a.analyser,
      status = _a.status;

  return {
    audioContext: audioContext,
    analyser: analyser,
    status: status
  };
};

exports.useAudioVisualizerContext = useAudioVisualizerContext;